import SubmitButton from "./SubmitButton";
import AddButton from "./AddButton";
import { CopyButton, MoveDownButton, MoveUpButton, RemoveButton } from "./IconButton";

function buttonTemplates() {
  return {
    SubmitButton: SubmitButton,
    AddButton: AddButton,
    CopyButton: CopyButton,
    MoveDownButton: MoveDownButton,
    MoveUpButton: MoveUpButton,
    RemoveButton: RemoveButton
  };
}

export default buttonTemplates;